import { useSettings } from 'Settings'
import { Point } from 'Vectorgraph/Point'
import Graph from '../Graph'
import ValueTransform from 'ValueTransform'

const LTS = (props) => {
	let graph = []
	const [settings] = useSettings()

	const lts_inital_voltage = settings['supervisory level']['lts initial voltage'].value
	const sts_lts_always_connected = settings['supervisory']['always connect'].value
	const acc = settings['supervisory level']['v_lvl_acc'].value
	const v_bat_max_hi = ValueTransform(settings['supervisory level']['v_bat_max_hi'].value, acc)
	const v_bat_min_hi_dis = ValueTransform(settings['supervisory level']['v_bat_min_hi_dis'].value, acc)
	const v_bat_max_lo = ValueTransform(settings['supervisory level']['v_bat_max_lo'].value, acc)
	const v_bat_min_lo = ValueTransform(settings['supervisory level']['v_bat_min_lo'].value, acc)
	const v_apl_max_lo = ValueTransform(settings['supervisory level']['v_apl_max_lo'].value, acc)
	const v_apl_max_hi = ValueTransform(settings['supervisory level']['v_apl_max_hi'].value, acc)

	let lts_init = 0.65
	let lts_init_con = 1.2

	if (lts_inital_voltage === 1) {
		lts_init = 1.4
		lts_init_con = (v_bat_max_lo + v_bat_min_hi_dis) / 2
	}
		
	if (sts_lts_always_connected) {
		graph.push(Point(0, lts_init_con))
		graph.push(Point(1, lts_init_con))
		graph.push(Point(2, v_bat_max_hi))
		graph.push(Point(2.5, v_bat_max_lo))
		graph.push(Point(3, v_bat_max_hi))
	} else {
		graph.push(Point(0, lts_init))
		graph.push(Point(1, lts_init))
		graph.push(Point(1.25, lts_init))
		graph.push(Point(1.5, (v_bat_min_hi_dis  + lts_init) / 2))
		graph.push(Point(1.75, (v_bat_min_hi_dis  + lts_init) / 2))
		graph.push(Point(2, v_bat_min_hi_dis))
		graph.push(Point(2.25, v_bat_max_hi))
		graph.push(Point(2.5, v_bat_max_lo))
		graph.push(Point(2.75, v_bat_max_hi))
		graph.push(Point(3, v_bat_max_lo))
	}

	graph.push(Point(4, v_bat_min_lo))
	graph.push(Point(5, v_bat_min_lo))
	graph.push(Point(5.5, v_bat_min_hi_dis))

	if (v_apl_max_hi < v_bat_max_hi) {
		graph.push(Point(6, v_apl_max_lo))
	} else {
		graph.push(Point(6, v_bat_max_lo))
	}

	graph.push(Point(7, v_bat_max_hi))
	graph.push(Point(8, v_bat_min_lo))
	graph.push(Point(9, v_bat_min_lo))

	return (
		<Graph {...props} points={graph} />
	)
}

export default LTS
